module.exports = __webpack_public_path__ + "img/no-result@3x.22496ba4.png";